<template>
  <div class="accept-container">
    <iframe ref="iframe" frameborder="0" scrolling="auto" :src="url"></iframe>
  </div>
</template>

<script>
export default {
  name: 'IframeComponent',
  props: ['url'],
  methods: {
    setIframeWidth () {
      const deviceWidth = document.getElementsByClassName('app-main')[0].clientWidth
      const deviceHeight = document.documentElement.clientHeight - document.getElementsByClassName('h-topbar-wrapper')[0].clientHeight - document.getElementsByClassName('h-navbar-wrapper')[0].clientHeight - 16
      this.$nextTick(function () {
        this.$refs.iframe.style.width = deviceWidth + 'px'
        this.$refs.iframe.style.height = deviceHeight + 'px'
      })
    }
  },
  mounted () {
    const that = this
    that.setIframeWidth()
    window.addEventListener('resize', function () {
      that.setIframeWidth()
    })
  }
}
</script>

<style scoped>
.accept-container {
  font-size: 0;
}
</style>
